"use strict";

define('app/study/detail/study.detail.view',['rs/abstract.content.view', 'evisions/evimenu/evimenu', 'evisions/helper'], function (AbstractContentView, EVIMenu, helper) {
  var StudyDetailView = AbstractContentView.extend({
    events: {
      'click .new-document-btn:not(.specific)': 'handleCreateDocumentBtn',
      'click .study-delete-btn': 'handleDeleteStudyAction',
      'click .new-document-btn.specific': 'handleNewDocumentSpecificClick',
      'click .study-create-pdf-btn': 'handlePDFGenerationClick',
      'click .study-title-view': 'handleStudyTitleEditClick',
      'mousedown .study-title-input .btn': 'handleStudyEditMousedown',
      'mouseup  .study-title-input .btn': 'handleStudyEditMouseup',
      'keydown .study-title-input input': 'handleStudyTitleKeyDown',
      'blur .study-title-input input': 'handleStudyTitleBlur',
      'focus .study-title-input input': 'handleStudyTitleFocus',
      'click .study-link-proposal-btn': 'handleStudyProposalLink',
      'click .study-unlink-proposal-btn': 'handleStudyProposalUnlink',
      'open-collapse-menu': 'handleCollapseMenuToggle'
    },
    templates: {
      'study.detail.init': 'renderInitFragment',
      'study.detail.pdf': 'renderPDFStudyFragment',
      'document.details.pdf': 'renderPDFDocFragment',
      'study.contact.details': 'renderContactDetailsFragment'
    },
    getStudyTitle: function getStudyTitle() {
      return this.getStudyTitleInput().find('input').val();
    },
    getStudyTitleInput: function getStudyTitleInput() {
      return this.$('.study-title-input');
    },
    getStudyTitleView: function getStudyTitleView() {
      return this.$('.study-title-view');
    },
    handleStudyTitleBlur: function handleStudyTitleBlur(ev) {
      if (!this.cancelEdit) {
        this.handleStudyTitleChange();
      }
    },
    handleStudyTitleFocus: function handleStudyTitleFocus(ev) {
      this.cancelEdit = undefined;
    },
    handleStudyEditMouseup: function handleStudyEditMouseup(ev) {
      if (this.cancelEdit) {
        this.hideEditableInput();
        this.cancelEdit = false;
      }
    },
    handleStudyTitleKeyDown: function handleStudyTitleKeyDown(ev) {
      if (ev.keyCode == 13) {
        this.getStudyTitleInput().find('input').blur();
      }
    },
    handleStudyEditMousedown: function handleStudyEditMousedown(ev) {
      var el = $(ev.currentTarget);
      if (el.find('.fa-icon-times').length) {
        this.cancelEdit = true;
      }
    },
    handleStudyTitleChange: function handleStudyTitleChange() {
      var newTitle = this.getStudyTitle();
      this.getDelegate().requestStudyTitleChange(newTitle);
    },
    handleStudyTitleEditClick: function handleStudyTitleEditClick() {
      if (this.getDelegate().userHasPermission('MODIFY_STUDY')) {
        this.getStudyTitleInput().show().find('input').focus();
        this.getStudyTitleView().hide();
      }
    },
    hideEditableInput: function hideEditableInput() {
      var study = this.getDelegate().getStudyService().getStudy();
      this.getStudyTitleInput().find('input').val(study.getTitle());
      this.showStudyTitleSuccess();
      this.getStudyTitleInput().hide();
      this.getStudyTitleView().show();
    },
    showStudyTitleSuccess: function showStudyTitleSuccess() {
      this.$('.study-title-error').slideUp();
    },
    showStudyTitleError: function showStudyTitleError(message) {
      this.$('.study-title-error').find('.error-message').text(message).end().slideDown();
    },
    refreshEditableFields: function refreshEditableFields() {
      if (!this.getDelegate().userHasPermission('MODIFY_STUDY')) {
        this.$('.study-title-view').removeClass('editable-field');
      }
    },
    refreshStudyFields: function refreshStudyFields() {
      var study = this.getDelegate().getStudyService().getStudy();
      this.hideEditableInput();
      this.$('.study-title-view h2').text(study.getTitle());
    },
    render: function render(data) {
      this.$el.html(this.renderInitFragment(data));
      this.refreshEditableFields();
      this.setRendered();
    },
    refreshDocumentListContainerHeight: function refreshDocumentListContainerHeight() {
      var listContainer = this.getDocumentListContainer().parent(),
        outerContainer = this.getDocumentsContainer(),
        position = outerContainer.position(),
        totalHeight = 0;
      listContainer.css('height', '');
      totalHeight = this.$('.full-height').height();
      if (position) {
        listContainer.height(totalHeight - position.top);
      }
    },
    getDocumentDetailContainer: function getDocumentDetailContainer() {
      return this.$('.document-detail-container');
    },
    getDocumentListContainer: function getDocumentListContainer() {
      return this.$('.document-list-container');
    },
    getDocumentsContainer: function getDocumentsContainer() {
      return this.$('.documents-container');
    },
    getAssignmentTableContainer: function getAssignmentTableContainer() {
      return this.$('.assignment-list-container');
    },
    showCreateDocumentDropdown: function showCreateDocumentDropdown() {
      var templates = this.getDelegate().getStudyService().getTemplates(),
        items = null,
        that = this,
        el = this.$('.new-document-btn');
      items = _.map(templates, function (m) {
        return {
          id: m.getId(),
          text: m.getType()
        };
      });
      EVIMenu.show({
        className: 'rs-menu',
        element: el,
        container: el,
        caret: 'top-right',
        offset: {
          top: 46,
          left: -51
        }
      }, items).tap(function (i) {
        if (templates[i]) {
          that.getDelegate().requestCreateDocument(templates[i].id, templates[i].revisionNumber);
        }
      });
    },
    handleCreateDocumentBtn: function handleCreateDocumentBtn() {
      this.showCreateDocumentDropdown();
    },
    handleNewDocumentSpecificClick: function handleNewDocumentSpecificClick(ev) {
      var templates = this.getDelegate().getStudyService().getTemplates(),
        template = templates[0];
      if (template) {
        this.getDelegate().requestCreateDocument(template.id, template.revisionNumber);
      }
    },
    refreshCreateStudyButton: function refreshCreateStudyButton(templates) {
      var btn = this.$('.new-document-btn');
      if (!templates || !templates.length) {
        btn.parent().hide();
      } else {
        if (templates.length == 1) {
          btn.addClass('specific').find('span').text('Add ' + templates[0].getType() + ' Submission');
        } else {
          btn.removeClass('specific').find('span').text('Add Submission');
        }
        btn.parent().show();
      }
    },
    handleDeleteStudyAction: function handleDeleteStudyAction() {
      this.getDelegate().requestStudyDelete();
    },
    handlePDFGenerationClick: function handlePDFGenerationClick() {
      this.getDelegate().generatePDFDocument();
    },
    handleCollapseMenuToggle: function handleCollapseMenuToggle() {
      var that = this;
      _.delay(function () {
        that.refreshDocumentListContainerHeight();
      }, 400);
    },
    handleStudyProposalLink: function handleStudyProposalLink() {
      this.trigger('link-proposal');
    },
    handleStudyProposalUnlink: function handleStudyProposalUnlink(ev) {
      var id = $(ev.currentTarget).data('id');
      this.trigger('unlink-proposal', id);
    },
    getDocumentPDFElement: function getDocumentPDFElement(data) {
      var fragment = this.renderPDFDocFragment(data),
        el = $('<body></body>');
      el.append(fragment);
      return el;
    },
    getStudyDocumentPDFElement: function getStudyDocumentPDFElement(data) {
      var fragment = this.renderPDFStudyFragment(data),
        el = $('<body></body>');
      el.append(fragment);
      return el;
    },
    getStudyContactElement: function getStudyContactElement() {
      return this.$('.study-contact-details');
    },
    getSelectedChildDecisionType: function getSelectedChildDecisionType() {
      return this.$('.child-decision-type-selector').val();
    },
    getStudyDeleteBtn: function getStudyDeleteBtn() {
      return this.$('.study-delete-btn');
    },
    showDeleteBtn: function showDeleteBtn() {
      this.getStudyDeleteBtn().parent().show();
    },
    hideDeleteBtn: function hideDeleteBtn() {
      this.getStudyDeleteBtn().parent().hide();
    },
    resize: function resize() {
      this._super.apply(this, arguments);
      this.refreshDocumentListContainerHeight();
    }
  });
  return StudyDetailView;
});

